import React, { useEffect, useState } from "react";
import { instanceMob } from "../../../utils/utils";
import BaseModal from "../../modals/base-modal";
import Dropdown from "../../dropdown/dropdown";
import "./styles.css"
import useLocationStore from "../config/use-location-store";
import { useNavigate } from "react-router-dom";

const LocationModal = ({ show, onClose }) => {
    const [locations, setLocations] = useState([]);
    const { selectedLocation, setSelectedLocation } = useLocationStore();
    const navigate = useNavigate();

    useEffect(() => {
        if (show) {
            getLocations();
        }
    }, [show]);

    const getLocations = () => {
        return instanceMob
            .get(`admin/location/list`)
            .then((res) => res.data)
            .then((data) => setLocations(data))
            .catch((err) => console.error(err));
    };

    const handleLocationSelect = (item) => {
        setSelectedLocation(item);
    };

    const handleConfirm = () => {
        if (selectedLocation) {
            onClose();
        }
    };

    const handleBack = () => {
        navigate(-1);
    };

    return (
        <BaseModal
            show={show}
            onClose={onClose}
            title="Selecciona la locación de la tienda"
            icon={
                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                    <g clip-path="url(#clip0_6034_31702)">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M12.229 12.2701C12.0465 12.4525 12.0465 12.7475 12.229 12.9299L15.029 15.7299C15.12 15.8209 15.2395 15.8667 15.3589 15.8667C15.4784 15.8667 15.5979 15.8209 15.6889 15.7299C15.8713 15.5475 15.8713 15.2525 15.6889 15.0701L12.8889 12.2701C12.7064 12.0876 12.4115 12.0876 12.229 12.2701ZM11.0222 14.1367C10.8397 13.9543 10.5448 13.9543 10.3623 14.1367C10.1799 14.3192 10.1799 14.6141 10.3623 14.7966L13.1623 17.5966C13.2533 17.6876 13.3728 17.7333 13.4923 17.7333C13.6117 17.7333 13.7312 17.6876 13.8222 17.5966C14.0047 17.4141 14.0047 17.1192 13.8222 16.9367L11.0222 14.1367ZM9.15553 16.0034C8.97307 15.8209 8.67813 15.8209 8.49567 16.0034C8.3132 16.1859 8.3132 16.4808 8.49567 16.6633L11.2957 19.4633C11.3867 19.5543 11.5061 19.6 11.6256 19.6C11.7451 19.6 11.8645 19.5543 11.9555 19.4633C12.138 19.2808 12.138 18.9859 11.9555 18.8034L9.15553 16.0034ZM17.9657 14.9333L13.0256 9.9932L6.2188 16.8L11.1589 21.7401L17.9657 14.9333ZM13.3555 9.0034L18.9555 14.6034C19.138 14.7859 19.138 15.0808 18.9555 15.2633L11.4889 22.7299C11.3979 22.8209 11.2784 22.8667 11.1589 22.8667C11.0395 22.8667 10.92 22.8209 10.829 22.7299L5.229 17.1299C5.04653 16.9475 5.04653 16.6525 5.229 16.4701L12.6957 9.0034C12.8781 8.82093 13.1731 8.82093 13.3555 9.0034ZM24.2139 17.0683C23.9909 16.9372 23.7053 17.0123 23.5751 17.2349L18.2261 26.3583C17.8397 27.027 16.9815 27.2571 16.3338 26.8837L15.2917 26.2085C15.0761 26.068 14.7868 26.1301 14.6468 26.3461C14.5063 26.5627 14.5679 26.8515 14.7845 26.9915L15.8466 27.6799C16.2129 27.8913 16.6138 27.9916 17.0095 27.9916C17.8164 27.9916 18.6018 27.5739 19.0325 26.8277L24.3801 17.7067C24.5103 17.4846 24.4361 17.199 24.2139 17.0683ZM27.9589 2.33333V9.8C27.9589 11.2439 27.4997 12.3195 26.4222 13.3966L12.5631 27.2753C12.1221 27.7163 11.536 27.9585 10.9125 27.9585C10.2891 27.9585 9.7034 27.7163 9.26333 27.2753L0.683667 18.6961C0.242667 18.2551 0 17.6689 0 17.0455C0 16.422 0.242667 15.8363 0.683667 15.3958L12.8049 3.29093C9.63527 2.5704 7.66827 2.52187 7.0924 2.69033C7.33553 2.93907 8.09293 3.46733 9.92087 4.18787C10.1607 4.2826 10.2783 4.55327 10.1841 4.79313C10.0893 5.033 9.8182 5.1492 9.5788 5.05633C5.79507 3.56487 6.01627 2.73793 6.0998 2.42667C6.27293 1.778 7.1974 1.56193 9.09113 1.7276C10.6335 1.86247 12.6243 2.2428 14.6967 2.79767C16.7692 3.353 18.6825 4.01893 20.0853 4.67367C21.8097 5.47773 22.5008 6.12593 22.3267 6.77507C22.1587 7.40133 21.2856 7.47787 20.9986 7.50307C20.9851 7.50447 20.9711 7.50493 20.9575 7.50493C20.7181 7.50493 20.5147 7.32153 20.4932 7.07887C20.4703 6.8222 20.6603 6.59587 20.9174 6.57347C21.1162 6.5562 21.2483 6.52913 21.3337 6.50487C21.1339 6.29627 20.6285 5.971 19.8203 5.58367C19.6509 5.86927 19.5589 6.19733 19.5589 6.53333C19.5589 7.5628 20.3961 8.4 21.4256 8.4C22.4551 8.4 23.2923 7.5628 23.2923 6.53333C23.2923 5.50387 22.4551 4.66667 21.4256 4.66667C21.1675 4.66667 20.9589 4.45807 20.9589 4.2C20.9589 3.94193 21.1675 3.73333 21.4256 3.73333C22.9698 3.73333 24.2256 4.98913 24.2256 6.53333C24.2256 8.07753 22.9698 9.33333 21.4256 9.33333C19.8814 9.33333 18.6256 8.07753 18.6256 6.53333C18.6256 6.06527 18.7488 5.60933 18.9686 5.2024C17.8519 4.7334 16.3539 4.2084 14.4555 3.69927C14.2553 3.6456 14.0625 3.5966 13.8698 3.5476L1.34353 16.0561C1.07893 16.3203 0.933333 16.6721 0.933333 17.0455C0.933333 17.4197 1.07893 17.7711 1.34353 18.0357L9.9232 26.6154C10.4519 27.1441 11.3741 27.1441 11.9028 26.6154L25.7619 12.7367C26.6714 11.8277 27.0256 11.004 27.0256 9.8V2.33333C27.0256 1.56147 26.3975 0.933333 25.6256 0.933333H18.1589C16.9549 0.933333 16.1313 1.28753 15.2222 2.1966C15.0397 2.37907 14.7448 2.37907 14.5623 2.1966C14.3799 2.01413 14.3799 1.7192 14.5623 1.53673C15.6394 0.4592 16.7151 0 18.1589 0H25.6256C26.9122 0 27.9589 1.04673 27.9589 2.33333Z" fill="#3177BE" />
                    </g>
                    <defs>
                        <clipPath id="clip0_6034_31702">
                            <rect width="28" height="28" fill="white" />
                        </clipPath>
                    </defs>
                </svg>
            }
            footer={true}
            closable={false}
            className="location-modal"
            onSave={handleConfirm}
            backable={true}
            onBack={handleBack}
            saveText="Continuar"
            disableSave={!selectedLocation}
        >
            <p className="location-modal-description text-center mb-0">
                Antes de comenzar a gestionar la tienda, debes seleccionar la{" "}
                <b>locación</b> en la que te encuentras. Esto es importante porque todos
                los módulos del sistema —inventario, ingresos, egresos, cuentas por
                cobrar y movimientos de caja— se vincularán automáticamente a la sucursal
                elegida.
            </p>

            <div className="d-flex justify-content-center">
                <Dropdown
                    items={locations.map((loc) => ({ id: loc.id, name: loc.name }))}
                    onSelect={handleLocationSelect}
                    placeholder="Selecciona tu locación"
                    showLabel={false}
                />
            </div>
        </BaseModal>
    );
};

export default LocationModal;
